import React, { useState, useEffect } from 'react';
import Breadcumb from '../../Layouts/Breadcumb';
import { Grid, TextField } from '@mui/material';
import DashboardNav from './DashboardNav';
import Select from 'react-select';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { jwtDecode } from 'jwt-decode'; // Corrected import
import { Constants } from '../../endPoints';

const MySwal = withReactContent(Swal);

const Profile = () => {
  const navigate = useHistory();
  const [user, setUser] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [imagePreview, setImagePreview] = useState(null); // State to hold the image preview

  // Fetch user data using customer ID from the access token
  useEffect(() => {
    const fetchUserData = async () => {
      const accessToken = localStorage.getItem('authToken');

      if (!accessToken) {
        console.error('No access token found');
        return;
      }

      const decodedToken = jwtDecode(accessToken);
      const id = decodedToken.id;

      try {
        const response = await axios.get(`${Constants.userInfoById}/${id}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const userData = response.data.data;
        setUser(userData);

        if (userData.country_id) await fetchStates(userData.country_id);
        if (userData.state_id) await fetchCities(userData.state_id);
        setImagePreview(userData.image ? `${Constants.imageBaseURL}/${userData.image}` : null); // Set image preview
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUserData();
  }, []);

  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    fetchCountries();
  }, []);

  const fetchStates = async (countryId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getStatecountryById}/${countryId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setStates(response.data.data);
      setCities([]); // Clear cities when country changes
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchCities = async (stateId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getCityStateById}/${stateId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setCities(response.data.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  // Define initial values
  const initialValues = user ? {
    name: user.name || '',
    // firstname: user.firstname || '',
    // lastname: user.lastname || '',
    email: user.email || '',
    phone: user.phone || '',
    country_id: user.country_id || '',
    state_id: user.state_id || '',
    city_id: user.city_id || '',
    image: null,
  } : {
    name: '',
    // firstname: '',
    // lastname: '',
    email: '',
    phone: '',
    country_id: '',
    state_id: '',
    city_id: '',
    image: null,
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    // firstname: Yup.string().required('First Name is required'),
    // lastname: Yup.string().required('Last Name is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
    phone: Yup.string().required('Phone is required'),
    country_id: Yup.string().required('Country is required'),
    state_id: Yup.string().required('State is required'),
    city_id: Yup.string().required('City is required'),
  });

  const onSubmit = async (values, { setSubmitting }) => {
    const accessToken = localStorage.getItem('authToken');

    try {
      const formData = new FormData();
      formData.append('name', values.name);
      // formData.append('firstname', values.firstname);
      // formData.append('lastname', values.lastname);
      formData.append('email', values.email);
      formData.append('phone', values.phone);
      formData.append('country_id', values.country_id);
      formData.append('state_id', values.state_id);
      formData.append('city_id', values.city_id);
      if (values.image) {
        formData.append('image', values.image);
      }

      await axios.put(`${Constants.editRegister}/${user.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      MySwal.fire({
        title: 'Success!',
        text: 'User updated successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate.push('/profile');
      });
    } catch (error) {
      MySwal.fire({
        title: 'Error!',
        text: 'There was an error updating the user.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      console.error('Error updating user:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const countryOptions = countries.map(country => ({
    value: country.id,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={`${country.country_symbols}`}
          alt={`${country.country} Flag`}
          style={{ width: '20px', marginRight: '10px' }}
        />
        {country.country}
      </div>
    ),
  }));

  const stateOptions = states.map(state => ({ value: state.id, label: state.name }));
  const cityOptions = cities.map(city => ({ value: city.id, label: city.name }));

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Get the selected file
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set the preview image as the file content
      };
      reader.readAsDataURL(file); // Read the file as data URL
    }
  };

  return (
    <>
      <Breadcumb pagetitle="Profile" />
      <section className="py-12">
        <div className="container mx-auto px-4">
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
              >
                {({ setFieldValue, isSubmitting }) => (
                  <Form className="form-profile">
                    <h2 className="text-3xl font-bold mb-5">Account Information</h2>
                    <Grid container spacing={3}>
                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="firstname" as={TextField} label="First Name" variant="outlined" fullWidth />
                        <ErrorMessage name="firstname" component="div" className="text-red-500" />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="lastname" as={TextField} label="Last Name" variant="outlined" fullWidth />
                        <ErrorMessage name="lastname" component="div" className="text-red-500" />
                      </Grid> */}
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="name" as={TextField} label="Name" variant="outlined" fullWidth />
                        <ErrorMessage name="name" component="div" className="text-red-500" />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="email" as={TextField} label="Email" variant="outlined" fullWidth disabled />
                        <ErrorMessage name="email" component="div" className="text-red-500" />
                      </Grid>
                    </Grid>

                    <h2 className="text-3xl font-bold mb-5 mt-10">Address Information</h2>
                    <Grid container spacing={3}>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Select
                          options={countryOptions}
                          onChange={(option) => {
                            setFieldValue('country_id', option.value);
                            fetchStates(option.value);
                          }}
                          placeholder="Select Country"
                          isSearchable
                          value={countryOptions.find(option => option.value === initialValues.country_id)}
                        />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Select
                          options={stateOptions}
                          onChange={(option) => {
                            setFieldValue('state_id', option.value);
                            fetchCities(option.value);
                          }}
                          placeholder="Select State"
                          isSearchable
                          value={stateOptions.find(option => option.value === initialValues.state_id)}
                        />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Select
                          options={cityOptions}
                          onChange={(option) => setFieldValue('city_id', option.value)}
                          placeholder="Select City"
                          isSearchable
                          value={cityOptions.find(option => option.value === initialValues.city_id)}
                        />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <Field name="phone" as={TextField} label="Phone" variant="outlined" fullWidth />
                        <ErrorMessage name="phone" component="div" className="text-red-500" />
                      </Grid>
                    </Grid>

                    <h2 className="text-3xl font-bold mb-5 mt-10">Profile Image</h2>
                    <input
                      type="file"
                      name="image"
                      onChange={(e) => {
                        setFieldValue('image', e.target.files[0]);
                        handleImageChange(e);
                      }}
                    />
                    <div className="mt-5">
                      {imagePreview && <img src={imagePreview} alt="Preview" className="w-32 h-32 object-cover" />}
                    </div>

                    <div className="mt-5">
                      <button
                        type="submit"
                        className="h-14 px-8 border rounded bg-[#b3902d] min-w-32 text-white font-semibold"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Updating...' : 'Update Profile'}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
};

export default Profile;
